let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("60eaG")).then(() => parcelRequire('8mRWC'));